import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import {
  IonLabel,
  IonList,
  IonItem,
  IonButton,
  IonModal,
  IonContent,
  IonFooter,
  IonToggle,
} from '@ionic/angular/standalone';
import { TranslatePipe } from '@ngx-translate/core';
import { GlobalPageHeaderComponent } from '../../global-page-header/global-page-header.component';
import { LabelConfigurationWarningMode } from '../label-configuration/label-configuration.component';

@Component({
  selector: 'app-switch-configuration',
  templateUrl: './switch-configuration.component.html',
  styleUrls: ['./switch-configuration.component.scss'],
  standalone: true,
  imports: [
    IonLabel,
    IonList,
    IonItem,
    IonButton,
    IonModal,
    IonContent,
    IonFooter,
    TranslatePipe,
    GlobalPageHeaderComponent,
    IonToggle,
  ],
})
export class SwitchConfigurationComponent {
  @Input() title?: string;
  @Input() nameCustom: string = '';
  @Input() value: boolean = false;
  @Input() description?: string;
  @Input() information?: () => void;
  @Input() warningMode?: LabelConfigurationWarningMode =
    LabelConfigurationWarningMode.NONE;

  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onPress = new EventEmitter<any>();

  constructor() {}

  callInformation() {
    if (this.information) {
      this.information();
    }
  }

  onTogglePress() {
    this.onPress.emit(!this.value);
  }

  protected readonly LabelConfigurationWarningMode =
    LabelConfigurationWarningMode;
}
